import { RequirePermission } from '@saniplus/ui';
import { Navigate, type RouteObject } from 'react-router';

import { PermissionFallback } from '../../components/shared/PermissionFallback';

/**
 * The three Tâches routes (Phase 5 / `docs/tracks/PHASE-5-TASKS.md` §5),
 * gated on `task:read` — the permission `GET /tasks` itself demands, same
 * shape as `pointages/routes.tsx`. `/taches/nouvelle` carries a second,
 * nested gate on `task:write`, because it is a write the nav already hides
 * from anyone without it (`nav.ts`); a direct visit without the permission
 * bounces back to the list rather than opening a dialog whose submit would
 * only be refused.
 *
 * `nouvelle` is declared before `:id`, mirroring `pointages/routes.tsx`'s
 * `en-cours` note — a literal segment ahead of the dynamic one, so a typo or
 * a stale link is never read as a task id.
 */
export const routes: RouteObject[] = [
  {
    path: '/taches',
    element: <RequirePermission permission="task:read" fallback={<PermissionFallback />} />,
    children: [
      {
        index: true,
        lazy: async () => ({
          Component: (await import('./pages/TasksListPage')).TasksListPage,
        }),
      },
      {
        path: 'nouvelle',
        element: (
          <RequirePermission permission="task:write" fallback={<Navigate to="/taches" replace />} />
        ),
        children: [
          {
            index: true,
            lazy: async () => ({
              Component: (await import('./pages/TasksListPage')).TasksListPage,
            }),
          },
        ],
      },
      {
        path: ':id',
        lazy: async () => ({
          Component: (await import('./pages/TaskDetailPage')).TaskDetailPage,
        }),
      },
    ],
  },
];
